/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { Modal } from 'antd';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Text } from '@/primitives/Text';
import { tokens } from '@/theme';

export type DeleteFleetModalProps = {
  open: boolean;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function DeleteFleetModal({ open, isDeleting, onConfirm, onCancel }: DeleteFleetModalProps) {
  const { t } = useMimicTranslation('fleets');

  return (
    <Modal
      open={open}
      title={t('deleteModal.title')}
      okText={t('deleteModal.delete')}
      okButtonProps={{
        danger: true,
        loading: isDeleting,
        style: { backgroundColor: tokens.color.red.red07 },
      }}
      onOk={onConfirm}
      onCancel={onCancel}
      destroyOnClose
    >
      <Text>{t('deleteModal.body')}</Text>
    </Modal>
  );
}
